"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function lotlan2egsa_xy(lotlan) {
    let xy = lonlat2egsa87(lotlan);
    // console.log(lotlan);
    return { _x: xy[0], _y: xy[1] };
}
exports.lotlan2egsa_xy = lotlan2egsa_xy;
function latlon2egsa87(latlon) {
    return lonlat2egsa87([latlon[1], latlon[0]]);
}
exports.latlon2egsa87 = latlon2egsa87;
function lonlat2egsa87(lonlat) {
    let k0 = 0.9996;
    let ggrs87_ell_a = 6378137;
    let ggrs87_ell_b = 6356752.314;
    let ggrs87_ell_f = 1 / 298.257223563;
    let ggrs87_ell_e = Math.sqrt(2 * ggrs87_ell_f - ggrs87_ell_f * ggrs87_ell_f);
    let wgs84_ggrs87_dX = 199.723;
    let wgs84_ggrs87_dY = -74.03;
    let wgs84_ggrs87_dZ = -246.018;
    let [longitude, latitude] = lonlat;
    let par = Math.sqrt(1 - (ggrs87_ell_e * ggrs87_ell_e * Math.sin(latitude * Math.PI / 180) * Math.sin(latitude * Math.PI / 180)));
    let n = ggrs87_ell_a / (Math.sqrt(1 - (ggrs87_ell_e * ggrs87_ell_e * Math.sin(latitude * Math.PI / 180) * Math.sin(latitude * Math.PI / 180))));
    let h = 0;
    let W_x = (n + h) * Math.cos(latitude * Math.PI / 180) * Math.cos(longitude * Math.PI / 180);
    let W_y = (n + h) * Math.cos(latitude * Math.PI / 180) * Math.sin(longitude * Math.PI / 180);
    let W_z = (n * (1 - ggrs87_ell_e * ggrs87_ell_e) + h) * Math.sin(latitude * Math.PI / 180);
    let E_x = W_x + wgs84_ggrs87_dX;
    let E_y = W_y + wgs84_ggrs87_dY;
    let E_z = W_z + wgs84_ggrs87_dZ;
    let E_mik = Math.atan(E_y / E_x) * 180 / Math.PI;
    let F0 = Math.atan(E_z / ((1 - ggrs87_ell_e * ggrs87_ell_e) * Math.sqrt(E_x * E_x + E_y * E_y)));
    let f1 = Math.atan((E_z + ggrs87_ell_e * ggrs87_ell_e * (ggrs87_ell_a / par) * Math.sin(F0)) / (Math.sqrt(E_x * E_x + E_y * E_y)));
    while (Math.abs(F0 - f1) > 0.000000001 * Math.PI / 180) {
        F0 = f1;
        f1 = Math.atan((E_z + ggrs87_ell_e * ggrs87_ell_e * (ggrs87_ell_a / par) * Math.sin(F0)) / (Math.sqrt(E_x * E_x + E_y * E_y)));
    }
    let E_plat = f1 * 180 / Math.PI;
    longitude = E_mik * Math.PI / 180;
    latitude = E_plat * Math.PI / 180;
    n = ggrs87_ell_a / (Math.sqrt(1 - (ggrs87_ell_e * ggrs87_ell_e * Math.sin(latitude) * Math.sin(latitude))));
    let e2 = ggrs87_ell_e * ggrs87_ell_e;
    let e4 = e2 * e2;
    let e6 = e2 * e2 * e2;
    let e8 = e2 * e2 * e2 * e2;
    let M0 = 1 + 3 * e2 / 4 + 45 * e4 / 64 + 175 * e6 / 256 + 11025 * e8 / 16384;
    let m2 = 3 * e2 / 8 + 15 * e4 / 32 + 525 * e6 / 1024 + 2205 * e8 / 4096;
    let M4 = 15 * e4 / 256 + 105 * e6 / 1024 + 2205 * e8 / 8820;
    let M6 = 35 * e6 / 3072 + 315 * e8 / 12288;
    let M8 = 315 * e8 / 130784;
    let m = ggrs87_ell_a * (1 - e2) * (M0 * latitude - m2 * Math.sin(2 * latitude) + M4 * Math.sin(4 * latitude) - M6 * Math.sin(6 * latitude) + M8 * Math.sin(8 * latitude));
    let L0 = 24 * Math.PI / 180;
    let et = ggrs87_ell_e;
    let cosf = Math.cos(latitude);
    let tanf = Math.tan(latitude);
    let dl = longitude - L0;
    longitude = dl * cosf;
    let n2 = et * et * cosf * cosf / (1 - et * et);
    let t = tanf;
    let x = (((5 - 18 * t * t + t * t * t * t + 14 * n2 - 58 * t * t * n2) * longitude * longitude / 120 + (1 - t * t + n2) / 6) * longitude * longitude + 1) * longitude * k0 * n + 500000;
    let y = m + (n * t / 2) * longitude * longitude + (n * t / 24) * (5 - t * t + 9 * n2 + 4 * n2 * n2) * longitude * longitude * longitude * longitude + (n * t / 720) * (61 - 58 * t * t) * longitude * longitude * longitude * longitude * longitude * longitude;
    y = y * k0;
    return [x, y];
}
exports.lonlat2egsa87 = lonlat2egsa87;
function egsa872lonlat(xy) {
    let k0 = 0.9996;
    let ggrs87_ell_a = 6378137;
    let ggrs87_ell_b = 6356752.314;
    let ggrs87_ell_f = 1 / 298.257223563;
    let ggrs87_ell_e = Math.sqrt(2 * ggrs87_ell_f - ggrs87_ell_f * ggrs87_ell_f);
    let wgs84_ggrs87_dX = 199.723;
    let wgs84_ggrs87_dY = -74.03;
    let wgs84_ggrs87_dZ = -246.018;
    let [x, y] = [xy[0], xy[1]];
    //var out = new Array();
    let F0;
    let dy;
    let df;
    let m;
    let DX;
    DX = x - 500000;
    let L0;
    L0 = 24;
    F0 = 10;
    dy = 10;
    df = 10;
    while (Math.abs(dy) > 0.0000005) {
        let e = ggrs87_ell_e;
        let a = ggrs87_ell_a;
        let M0 = 1 + 3 * Math.pow(e, 2) / 4 + 45 * Math.pow(e, 4) / 64 + 175 * Math.pow(e, 6) / 256 + 11025 * Math.pow(e, 8) / 16384;
        let m2 = 3 * Math.pow(e, 2) / 8 + 15 * Math.pow(e, 4) / 32 + 525 * Math.pow(e, 6) / 1024 + 2205 * Math.pow(e, 8) / 4096;
        let M4 = 15 * Math.pow(e, 4) / 256 + 105 * Math.pow(e, 6) / 1024 + 2205 * Math.pow(e, 8) / 8820;
        let M6 = 35 * Math.pow(e, 6) / 3072 + 315 * Math.pow(e, 8) / 12288;
        let M8 = 315 * Math.pow(e, 8) / 130784;
        m = a * (1 - Math.pow(e, 2)) * (M0 * F0 * Math.PI / 180 - m2 * Math.sin(2 * F0 * Math.PI / 180) + M4 * Math.sin(4 * F0 * Math.PI / 180) - M6 * Math.sin(6 * F0 * Math.PI / 180) + M8 * Math.sin(8 * F0 * Math.PI / 180));
        if (y / k0 - m > 0) {
            F0 = F0 + df;
        }
        if (y / k0 - m < 0) {
            df = df / 2;
            F0 = F0 - df;
        }
        dy = y / k0 - m;
    }
    F0 = F0;
    let ee;
    ee = ggrs87_ell_e;
    let et;
    et = Math.sqrt(ee * ee / (1 - ee * ee));
    let aa;
    aa = ggrs87_ell_a;
    let bb;
    bb = ggrs87_ell_b;
    let N0;
    N0 = aa / Math.sqrt(1 - ee * ee * Math.sin(F0 * Math.PI / 180) * Math.sin(F0 * Math.PI / 180));
    let p0;
    p0 = aa * (1 - ee * ee) / Math.sqrt(Math.pow((1 - ee * ee * Math.sin(F0 * Math.PI / 180) * Math.sin(F0 * Math.PI / 180)), 3));
    let t0;
    t0 = Math.tan(F0 * Math.PI / 180);
    let nn0;
    nn0 = Math.sqrt(et * et * Math.cos(F0 * Math.PI / 180) * Math.cos(F0 * Math.PI / 180));
    let f;
    let l;
    f = F0 - ((t0 / (2 * k0 * k0 * N0 * p0))) * DX * DX * 180 / Math.PI;
    f = f + ((t0 / (24 * k0 * k0 * k0 * k0 * p0 * N0 * N0 * N0)) * (5 + 3 * t0 * t0 + nn0 * nn0 - 4 * nn0 * nn0 * nn0 * nn0 - 9 * t0 * t0 * nn0 * nn0)) * DX * DX * DX * DX * 180 / Math.PI;
    f = f - ((t0 / (720 * Math.pow(k0, 6) * p0 * Math.pow(N0, 5))) * (61 + 90 * Math.pow(t0, 2) + 45 * Math.pow(t0, 4))) * Math.pow(DX, 6) * 180 / Math.PI;
    l = L0 + (1 / (k0 * N0 * Math.cos(F0 * Math.PI / 180))) * DX * 180 / Math.PI;
    l = l - (1 / (6 * Math.pow(k0, 3) * Math.pow(N0, 3) * Math.cos(F0 * Math.PI / 180))) * (1 + 2 * Math.pow(t0, 2) + Math.pow(nn0, 2)) * Math.pow(DX, 3) * 180 / Math.PI;
    l = l + (1 / (120 * Math.pow(k0, 5) * Math.pow(N0, 5) * Math.cos(F0 * Math.PI / 180))) * (5 + 6 * Math.pow(nn0, 2) + 28 * Math.pow(t0, 2) + 8 * Math.pow(t0, 2) * Math.pow(nn0, 2) + 24 * Math.pow(t0, 4) - 3 * Math.pow(nn0, 4) - 4 * Math.pow(nn0, 6) + 4 * Math.pow(t0, 2) * Math.pow(nn0, 4) + 24 * Math.pow(t0, 2) * Math.pow(nn0, 6)) * Math.pow(DX, 5) * 180 / Math.PI;
    //l = l - (1 / (5040 *  Math.pow(k0 ,7) * Math.pow(N0, 7) * Math.cos(F0 * pi / 180))) * (61 + 66 *  Math.pow(t0 ,2) + 1320 *  Math.pow(t0 , 4) + 720 *  Math.pow(t0 , 6)) *  Math.pow(DX, 7) * 180 / pi;
    let par = Math.sqrt(1 - (ggrs87_ell_e * ggrs87_ell_e * Math.sin(f * Math.PI / 180) * Math.sin(f * Math.PI / 180)));
    let n = ggrs87_ell_a / (Math.sqrt(1 - (ggrs87_ell_e * ggrs87_ell_e * Math.sin(f * Math.PI / 180) * Math.sin(f * Math.PI / 180))));
    let h = 0;
    let E_x = (n + h) * Math.cos(f * Math.PI / 180) * Math.cos(l * Math.PI / 180);
    let E_y = (n + h) * Math.cos(f * Math.PI / 180) * Math.sin(l * Math.PI / 180);
    let E_z = (n * (1 - ggrs87_ell_e * ggrs87_ell_e) + h) * Math.sin(f * Math.PI / 180);
    // let dx = 0;
    // dy = 0;
    // let dz = 0;
    let W_x = E_x - wgs84_ggrs87_dX;
    let W_y = E_y - wgs84_ggrs87_dY;
    let W_z = E_z - wgs84_ggrs87_dZ;
    let E_mik = Math.atan(W_y / W_x) * 180 / Math.PI;
    F0 = Math.atan(E_z / ((1 - ggrs87_ell_e * ggrs87_ell_e) * Math.sqrt(W_x * W_x + W_y * W_y)));
    var f1 = Math.atan((W_z + ggrs87_ell_e * ggrs87_ell_e * (ggrs87_ell_a / par) * Math.sin(F0)) / (Math.sqrt(W_x * W_x + W_y * W_y)));
    while (Math.abs(F0 - f1) > 0.000000001 * Math.PI / 180) {
        F0 = f1;
        f1 = Math.atan((W_z + ggrs87_ell_e * ggrs87_ell_e * (ggrs87_ell_a / par) * Math.sin(F0)) / (Math.sqrt(W_x * W_x + W_y * W_y)));
    }
    var E_plat = f1 * 180 / Math.PI;
    l = E_mik;
    f = E_plat;
    return [l, f];
}
exports.egsa872lonlat = egsa872lonlat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/gs-geo/dist/egsa.js
// module id = 7
// module chunks = 0